import endpoints from 'config/endpoints';
//import {PERIOD_TYPES} from 'config/constants/period';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE /*TRUE_VALUE*/} from 'util/constants';
import {getColor} from 'util/reports';


const createParams = params => ({
    entity:    params.entity,
    exclude:   params.exclude,
    id:        params.id,
    startDate: params.period.startDate,
    endDate:   params.period.endDate,
    search:    params.search,
    service:   params.service
});
const name = 'reportsDetailed',
    exports = {
        createParams,
        ...storeModuleFactory({
            name,
            endpoint:           endpoints.reports.endpoint_v2,
            timeout:            TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
            transformResultsFn: json => {
                const ret = {
                    ...json,
                    items: [
                        ...json.items.map((item, index) => {
                            const obj = {
                                ...item,
                                section: json.type
                            };


                            return {
                                ...obj,
                                color: getColor(obj, index)
                            };
                        })
                    ]
                };

                return [ret];
            },
            parseParameters: params => ({
                ...params,
                startDate: Math.floor(params.startDate / TIMESTAMP_MULTIPLY),
                endDate:   Math.floor(params.endDate / TIMESTAMP_MULTIPLY),
                level:     params.level ? params.level.join() : undefined,
                language:  params.language ? params.language : undefined
            }),
            filterParamsMap: {
                startDate: 'start_date',
                endDate:   'end_date'
            }
        })
    };


module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/reportsDetailed.js